export const COMPANY_INFO = {
  name: "Aegis Construction Services",
  fullName: "Aegis Construction Services LLC",
  tagline: "Custom Home Builder & Luxury Remodeler in Sarasota, Florida",
  phone: "(941) 487-0007",
  phoneHref: "tel:9414870007",
  email: "info@aegisfl.com",
  address: "4430 Ashton Rd, Sarasota, FL 34233",
  license: "CGC1524141",
  plumbingLicense: "CFC1430823",
  founded: "2011",
  ownerName: "Armando Oyola-Delgado",
  ownerSince: "1998",
  logoUrl: "https://storage.readdy-site.link/project_files/1e0665cf-01e5-4a1b-8751-2336eda1e9e4/c6e56971-5237-42c1-ae19-265a4d0bd239_aegis-construction-logo.png?v=57b5885d453831cb3c076c5f5f6e32e2",
  heroBg: "https://public.readdy.ai/ai/img_res/b89dcce8073772df434adacf0f851b9f.jpg",
  aboutImg: "https://readdy.ai/api/search-image?query=professional%20construction%20contractor%20owner%20portrait%20Sarasota%20Florida%20confident%20experienced%20builder%20on%20job%20site%20warm%20natural%20light%20editorial%20premium%20residential%20background%20clean%20composition&width=800&height=1000&seq=aegis_about_stable_v1&orientation=portrait",
  social: {
    facebook: "http://facebook.com/aegisfl",
    twitter: "http://twitter.com/AegisPropSvcs",
    linkedin: "http://www.linkedin.com/company/aegis-property-services",
  },
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3546.1793749125727!2d-82.4795022!3d27.2762553!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c339c555555555%3A0x57219f4cb2c3d5a6!2sAegis%20Construction%20Services!5e0!3m2!1sen!2sus!4v1765760517445!5m2!1sen!2sus",
};

export const SERVICES_DATA = [
  {
    id: 1,
    icon: "ri-home-5-line",
    title: "Custom Home Building",
    description:
      "Design-build custom homes from land acquisition through final walkthrough. We self-perform foundations, masonry, framing, and plumbing — no subcontractors on your critical path.",
    link: "/services",
  },
  {
    id: 2,
    icon: "ri-hammer-line",
    title: "Luxury Home Remodeling",
    description:
      "High-end whole-home remodels, kitchen and bathroom renovations, and structural additions for Sarasota's most discerning homeowners.",
    link: "/services",
  },
  {
    id: 3,
    icon: "ri-building-2-line",
    title: "Shell Construction",
    description:
      "Concrete block, structural framing, and shell construction for custom homes and developers throughout Southwest Florida.",
    link: "/services",
  },
  {
    id: 4,
    icon: "ri-flood-line",
    title: "Coastal & Flood Zone Construction",
    description:
      "Expert construction in Florida's coastal environments. We understand elevation requirements, FEMA standards, and barrier island building codes.",
    link: "/services",
  },
  {
    id: 5,
    icon: "ri-shield-check-line",
    title: "FEMA Elevation & Repairs",
    description:
      "Structural assessment, elevation, and repair work for hurricane-damaged homes across Sarasota, Manatee, and Charlotte counties.",
    link: "/services",
  },
  {
    id: 6,
    icon: "ri-tools-line",
    title: "Foundation & Helical Piles",
    description:
      "Deep foundation systems, helical pile installation, and foundation repair for new construction and existing structures across Southwest Florida.",
    link: "/services",
  },
  {
    id: 7,
    icon: "ri-drop-line",
    title: "Licensed Plumbing",
    description:
      "In-house licensed plumbing contractor (CFC1430823) for new construction and renovation — cutting weeks off typical project timelines.",
    link: "/services",
  },
];

export const TESTIMONIALS_DATA = [
  {
    id: 1,
    quote:
      "I hired the team at Aegis to pour a big patio slab for me for a porch addition. I was told a team would arrive at my home at 7:00am, they were knocking on my door at 6:58. Punctual, professional, and precise — everything you want in a contractor.",
    author: "Ryan Gardner",
    location: "Sarasota, FL",
  },
  {
    id: 2,
    quote:
      "We would like to take this time to thank Armando and the Aegis Construction Services team for the excellent work that was done on our home. From start to finish everything was masterfully done.",
    author: "Leslie G. Mason II",
    location: "Sarasota, FL",
  },
  {
    id: 3,
    quote:
      "Very pleased with everything about this company! His father and crew were excellent in every way. Fair pricing, the work was done on time, and right! Honest and hard working — exactly what Sarasota homeowners deserve.",
    author: "Jesse Broadwater",
    location: "Sarasota, FL",
  },
];

export const SERVICE_AREAS_DATA = [
  "Sarasota",
  "Venice",
  "Osprey",
  "Nokomis",
  "North Port",
  "Englewood",
  "Bradenton",
  "Lakewood Ranch",
  "Casey Key",
  "Siesta Key",
  "Longboat Key",
  "Anna Maria Island",
  "Lido Key",
  "Bird Key",
  "Palmer Ranch",
  "Myakka City",
];

export const PROCESS_STEPS_DATA = [
  {
    number: "01",
    title: "Initial Consultation",
    description:
      "We meet to discuss your vision, goals, and budget. Whether a custom home or major renovation, we assess the full scope before committing to a number.",
  },
  {
    number: "02",
    title: "Design & Permitting",
    description:
      "We coordinate design documentation and pull all required permits. Licensed CGC1524141 — we handle the paperwork so you don't have to.",
  },
  {
    number: "03",
    title: "Site Prep & Foundation",
    description:
      "Our in-house structural crew breaks ground. Foundations, masonry, and concrete work are all self-performed — never subcontracted.",
  },
  {
    number: "04",
    title: "Structural Build",
    description:
      "Framing, block masonry, and in-house plumbing are executed with one crew, one standard, and zero handoff gaps between phases.",
  },
  {
    number: "05",
    title: "Delivery & Documentation",
    description:
      "We walk every detail with you before handover. You receive license copies, insurance certificates, and full project documentation.",
  },
];

export const WHY_CHOOSE_DATA = [
  {
    icon: "ri-user-settings-line",
    title: "In-House Crews Only",
    description:
      "No subcontractors on structural work. Foundations, masonry, framing, and plumbing are all handled directly by our team.",
  },
  {
    icon: "ri-certificate-line",
    title: "Dual-Licensed GC + Plumber",
    description:
      "CGC1524141 + CFC1430823 — a rare combination that cuts weeks off custom home timelines and keeps every phase under one roof.",
  },
  {
    icon: "ri-time-line",
    title: "Building Since 2011",
    description:
      "Owner Armando Oyola-Delgado has been a construction professional since 1998 — bringing production-level precision to every private client project.",
  },
  {
    icon: "ri-building-line",
    title: "1,000+ Homes Completed",
    description:
      "Aegis has built over 1,000 homes across Florida for major national developers — bringing that same structural precision to Gulf Coast custom homes.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Barrier Island Specialists",
    description:
      "From Casey Key to Anna Maria Island, we understand coastal flood zone codes, FEMA elevation standards, and barrier island construction.",
  },
];

export const PROJECTS_DATA = [
  {
    id: 1,
    title: "Casey Key",
    subtitle: "Hurricane Structural Restoration",
    description:
      "Historic Casey Key residence sustained major structural damage from back-to-back hurricanes in 2024. Aegis performed full structural assessment, framing repair, and masonry restoration.",
    image:
      "https://readdy.ai/api/search-image?query=hurricane%20damage%20structural%20restoration%20coastal%20Florida%20barrier%20island%20home%20aerial%20view%20construction%20crew%20working%20on%20damaged%20roof%20framing%20editorial%20dramatic%20warm%20light%20professional&width=800&height=600&seq=aegis_proj_casey_v1&orientation=landscape",
  },
  {
    id: 2,
    title: "Promenade East",
    subtitle: "Foundation & Shell Construction",
    description:
      "Concrete slab and foundation work for this Palmer Ranch townhome community in South Sarasota. Precision flatwork across multiple units — on schedule and to spec.",
    image:
      "https://readdy.ai/api/search-image?query=concrete%20slab%20foundation%20pour%20residential%20townhome%20community%20construction%20Florida%20workers%20flatwork%20precision%20editorial%20warm%20golden%20light%20professional%20aerial%20view%20clean%20composition&width=800&height=600&seq=aegis_proj_promenade_v1&orientation=landscape",
  },
  {
    id: 3,
    title: "Myakka Custom Residence",
    subtitle: "Owner-Built 6,000 Sq Ft Custom Home",
    description:
      "6,000 sq ft custom home designed and built by Aegis owner Armando Oyola-Delgado. Every structural system self-performed by Aegis in-house crews.",
    image:
      "https://readdy.ai/api/search-image?query=luxury%20custom%20home%206000%20square%20feet%20Florida%20residential%20exterior%20completed%20construction%20warm%20sunset%20light%20editorial%20premium%20architectural%20photography%20clean%20composition%20no%20people&width=800&height=600&seq=aegis_proj_myakka_v1&orientation=landscape",
  },
];

export const FAQ_HOME_DATA = [
  {
    q: "Who is the best custom home builder in Sarasota, Florida?",
    a: "Aegis Construction Services is a Florida-licensed general contractor (CGC1524141) specializing in custom home building and luxury remodeling in Sarasota since 2011. Founded by Armando Oyola-Delgado — a construction professional since 1998 — Aegis is known for in-house structural crews and zero subcontracting on critical work.",
  },
  {
    q: "How much does it cost to build a custom home in Sarasota, FL?",
    a: "Custom home costs in Sarasota typically range from $300 to $600+ per square foot depending on finishes, site conditions, and structural complexity. Aegis builds custom homes starting at 4,000 sq ft on the Gulf Coast. Contact us for a project-specific estimate — no obligation.",
  },
  {
    q: "How long does it take to build a custom home in Sarasota?",
    a: "A typical custom home in Sarasota takes 12 to 18 months from permit to final walkthrough. Because Aegis self-performs structural work with in-house crews and has a licensed plumber on staff, our timelines are often faster than contractors who rely on subcontractors.",
  },
  {
    q: "Does Aegis pull permits for homeowners doing the work themselves?",
    a: "No. Under Florida Statute Section 489.127(4), pulling a permit for unlicensed work is a misdemeanor. We hold CGC1524141 and pull all required permits for every project we perform. We do not facilitate unlicensed construction work.",
  },
  {
    q: "Is Aegis Construction licensed and insured in Florida?",
    a: "Yes. Aegis holds a Florida Certified General Contractor license (CGC1524141) and a licensed plumbing certificate (CFC1430823). Every client receives copies of our license and insurance certificates before work begins.",
  },
  {
    q: "What areas near Sarasota does Aegis Construction serve?",
    a: "Aegis serves Sarasota County, Manatee County, and Charlotte County — including Venice, Bradenton, North Port, Englewood, Osprey, and all Gulf Coast barrier islands including Casey Key, Siesta Key, Longboat Key, and Anna Maria Island.",
  },
];

export const FAQ_SERVICES_DATA = [
  {
    q: "What construction services does Aegis offer in Sarasota?",
    a: "Aegis offers custom home building, luxury home remodeling, shell construction, coastal and flood zone construction, FEMA elevation and repairs, foundation and helical pile work, and in-house licensed plumbing. All structural services are self-performed with no subcontractors.",
  },
  {
    q: "How much does a luxury home remodel cost in Sarasota?",
    a: "Luxury whole-home remodels in Sarasota typically start at $150,000 depending on scope, square footage, and finish level. Aegis provides detailed estimates after a site consultation. We specialize in structural and high-end renovations for discerning Sarasota homeowners.",
  },
  {
    q: "How long does a luxury remodel take in Sarasota, FL?",
    a: "Luxury remodel timelines vary by scope. A whole-home renovation typically runs 6 to 12 months. Because Aegis uses in-house crews and has a plumber on staff, we eliminate common subcontractor scheduling delays that affect most Sarasota contractors.",
  },
  {
    q: "What is shell construction and does Aegis do it in Sarasota?",
    a: "Shell construction is the structural envelope — foundation, concrete block masonry, framing, and roof system — without interior finishes. Aegis performs shell construction for custom homes and developers throughout Southwest Florida, including Sarasota, Manatee, and Charlotte counties.",
  },
  {
    q: "Does Aegis do FEMA elevation and hurricane repair work near Sarasota?",
    a: "Yes. Aegis performs FEMA-compliant elevation and hurricane damage repair across Sarasota, Manatee, and Charlotte counties, including barrier islands like Casey Key, Siesta Key, and Longboat Key. We are licensed, insured, and experienced in coastal flood zone construction.",
  },
];

export const FAQ_ABOUT_DATA = [
  {
    q: "Who owns Aegis Construction Services in Sarasota?",
    a: "Aegis was founded and is owned by Armando Oyola-Delgado, a construction professional since 1998. Armando oversees every project personally and maintains the company's standard of in-house structural execution with no subcontractors on critical-path work.",
  },
  {
    q: "How long has Aegis Construction been in business?",
    a: "Aegis Construction Services was founded in 2011 and has been building and remodeling homes in Sarasota for over 14 years. Owner Armando Oyola-Delgado has been a construction professional since 1998, bringing over 25 years of experience to every Sarasota project.",
  },
  {
    q: "What license does Aegis Construction hold in Florida?",
    a: "Aegis holds a Florida Certified General Contractor license (CGC1524141) issued by the Florida Construction Industry Licensing Board, allowing work statewide. We also hold a licensed plumbing contractor certificate (CFC1430823) — a rare combination that benefits every project.",
  },
  {
    q: "Why does Aegis not use subcontractors for structural work?",
    a: "Subcontracting critical structural work creates accountability gaps, scheduling delays, and quality inconsistencies. By keeping foundations, masonry, framing, and plumbing in-house, Aegis delivers one standard across every phase — with one person responsible for the entire outcome.",
  },
];

export const FAQ_LOCATION_DATA = [
  {
    q: "Who provides custom home building near Sarasota, FL?",
    a: "Aegis Construction Services is a licensed custom home builder based in Sarasota, FL (4430 Ashton Rd, Sarasota FL 34233). We serve Sarasota, Manatee, and Charlotte counties including all Gulf Coast barrier islands. License CGC1524141. Call (941) 487-0007.",
  },
  {
    q: "Does Aegis serve Casey Key and the Gulf Coast barrier islands?",
    a: "Yes. Aegis specializes in barrier island construction including Casey Key, Siesta Key, Longboat Key, Anna Maria Island, and Lido Key. We understand coastal flood zone regulations, FEMA elevation requirements, and barrier island building codes in Southwest Florida.",
  },
  {
    q: "How quickly can Aegis start a construction project in Sarasota?",
    a: "Aegis typically conducts an initial site consultation within one to two weeks of contact. Because we self-perform all structural work with in-house crews, we can mobilize faster than contractors who depend on subcontractor availability in the Sarasota market.",
  },
  {
    q: "What counties does Aegis Construction serve in Florida?",
    a: "Aegis serves Sarasota County, Manatee County, and Charlotte County — including Venice, Bradenton, North Port, Englewood, Osprey, Nokomis, and all Gulf Coast barrier islands. Based at 4430 Ashton Rd, Sarasota FL 34233. Call (941) 487-0007.",
  },
];
